const Login = () => <div>Login</div>;

export default Login;
